// extracted by mini-css-extract-plugin
module.exports = {"spec":"tech-spec-module--spec--2tNru","heading":"tech-spec-module--heading--2zZMJ","description":"tech-spec-module--description--2w_0Q"};